






































import Vue from 'vue'

import PuzzleBoard from '@/components/PuzzleBoard.vue'
import PuzzleSpace from '@/components/PuzzleSpace.vue'
import { firestore, auth } from '../firebase'
import { mapState } from 'vuex'

export default Vue.extend({
  name: 'puzzle',
  components: { PuzzleBoard, PuzzleSpace },
  data: () => {
    return {
      completed: false,
      hint: [0, 0],
      loading: true,
      puzzleSpaces: [] as number[],
      showFinished: false,
      solution: [] as number[],
      spaces: [] as { empty: boolean; locked: boolean; piece: number }[],
      turns: 0,
      level: 0,
      pieceCount: 2,
      spaceCount: 1
    }
  },
  computed: {
    finished (): {[key:string]: any} {
      const message = this.points > 0 ? 'You repaired the circuit!' : 'Oops, you broke the circuit!'
      const state = this.points === 0 ? 'failure' : 'success'
      const nextText = state === 'failure' ? 'Retry' : 'Continue'
      return { message, state, nextText }
    },
    points (): number {
      return this.level * 20 + 10 - this.turns * 5
    },
    ready (): boolean {
      return this.spaceCount === this.spaces.length
    },
    spacesFull (): boolean {
      let result = 0
      this.spaces.forEach(space => {
        if (space.piece > -1) result += 1
      })
      return result === this.spaceCount
    }
  },
  methods: {
    changePiece (index: number) {
      const space = this.spaces[index]
      this.loading = true
      space.piece = (space.piece + 1) % this.pieceCount
      this.$set(this.spaces, index, space)
      this.loading = false
    },
    checkGuess () {
      if (this.completed === true) {
        alert('This puzzle is finished. Refresh to try again.')
      } else {
        this.loading = true
        const result = [0, 0]
        const solution1 = [...this.solution]
        const solution2 = [...this.solution]
        for (let i = 0; i < this.spaceCount; i++) {
          const piece = this.spaces[this.puzzleSpaces[i]].piece
          if (solution1[i] === piece) {
            result[1] += 1
          }
          if (solution2.indexOf(piece) > -1) {
            solution2.splice(solution2.indexOf(piece), 1)
            result[0] += 1
          }
        }
        this.hint = result
        this.loading = false
        if (result[1] === this.spaceCount) {
          this.completed = true
          this.showFinished = true
          const updateData = {
            circuitsFixed: firestore.FieldValue.increment(1),
            points: firestore.FieldValue.increment(this.level === 0 ? 100 : this.points)
          }
          firestore().doc(`users/${this.$store.state.user.uid}`).update(updateData)
        } else {
          this.turns = this.turns + 1
          Vue.nextTick().then(() => {
            if (this.points === 0) {
              const updateData = {
                circuitsBroken: firestore.FieldValue.increment(1)
              }
              firestore().doc(`users/${this.$store.state.user.uid}`).update(updateData)
              this.completed = true
              this.showFinished = true
            }
          })
        }
      }
    },
    reset () {
      const user = this.$store.state.user
      this.level = user.level
      this.spaceCount = user.level + 1
      this.pieceCount = user.level + 2
      this.turns = 0
      this.completed = false

      const emptySpaces = [] as number[]
      emptySpaces.push(Math.floor(Math.random() * this.spaceCount))

      let i = 1
      while (i < this.spaceCount) {
        const rand = Math.floor(Math.random() * this.spaceCount)
        if (emptySpaces.indexOf(rand) === -1) {
          emptySpaces.push(rand)
          i++
        }
      }

      emptySpaces.sort((a, b) => {
        return a > b ? 1 : -1
      })

      this.puzzleSpaces = emptySpaces

      // generate solution
      for (let i = 0; i < this.spaceCount; i++) {
        const piece = Math.floor(Math.random() * this.pieceCount)
        if (emptySpaces.indexOf(i) === -1) {
          this.$set(this.spaces, i, {
            empty: false,
            locked: true,
            piece: piece
          })
        } else {
          this.solution.push(piece)
          this.$set(this.spaces, i, {
            empty: true,
            locked: false,
            piece: -1
          })
        }
      }
      this.loading = false
    }
  },
  created () {
    const waitForUser = setInterval(() => {
      const authUser = auth().currentUser
      const user = this.$store.state.user
      if (authUser && authUser.uid === user.uid) {
        this.reset()
        clearInterval(waitForUser)
      }
    }, 50)
  }
})
